import React from 'react';
import UsageHistory from './UsageHistory';

const UsageHistoryPage = () => (
  <div>
    <UsageHistory />
  </div>
);

export default UsageHistoryPage; 